// extracted by mini-css-extract-plugin
module.exports = {"EditorChoice":"EditorChoice_EditorChoice__1CR6n","EditorChoicePrimary":"EditorChoice_EditorChoicePrimary__16Vqd","starIcon":"EditorChoice_starIcon__v1DN_"};